import React from 'react';

export const ERROR = {
  NOT_REGISTERED: 'You are not registered . Please click here to register',
  NOT_REGISTERED_COMPONENT: (
    <>
      You are not registered . Please click{' '}
      <a href="https://halan.com/">here</a> to register
    </>
  ),
};
